import JobStatistics from "@/components/jobs/JobStatistics";
import Overview from "@/components/Home/Overview";
import PublishStatistics from "@/components/release/PublishStatistics";
import React, { useEffect, useContext } from "react";
import { useRouter } from "next/router";
import Home from "@/components/Home/Home";
import axios from "axios";
import { useAuth } from "@/providers/AuthenticationProvider";
import { jobListConfig } from "@/api/jobs/apiConfig";
import { AppContext } from "@/providers/AppContext";

function Index() {
  const router = useRouter();
  const { apiEnv, accessToken, userProfile } = useAuth();
  const { firstLoadingJob, setFirstLoadingJob } = useContext(AppContext);
  useEffect(() => {
    // router.push("/jobs");
  });

  useEffect(() => {
    if (firstLoadingJob) return;
    getJobsForPerformance();
  }, []);

  const getJobsForPerformance = () => {
    const config = jobListConfig(apiEnv, userProfile, null, accessToken, [], [], null, [], "", "");
    axios(config)
      .then(function (response) { })
      .catch(function (error) { })
      .finally(function () {
        setFirstLoadingJob(true);
      });
  };

  return (
    <>
      <div data-test="homepage" style={{ width: "100%" }}>
        <Home />
      </div>
    </>
  );
}

export default Index;
